import {DashboardPanelData} from '../../../interfaces/Dashboard';
import {EventTotalKpi} from '../HazardAIEventTotal/EventTotalKpi';

interface Props {
  value?: DashboardPanelData;
  onUpdate?: (value?: DashboardPanelData) => void;
}

export const HazardAITotalHazardEvents = (props?: Props) => (
  <EventTotalKpi
    {...props}
    zone="hazard"
    label="Total Hazard Events"
    errorId="STRA_c7e9a1f3"
  />
);
